import {localStorage} from "@tencent/midas-util"
import * as request from "../utils/request"
import {computed, ref, ComputedRef} from "vue"
import {Store} from "../store"
import {PRODUCT_TYPE} from "../config"
import {getParam} from "../utils/url"

export async function getPropsConfig({
  url,
  version,
  cachekey,
}: {
  url: string
  version: string
  cachekey: string
}): Promise<any> {
  const cacheProps = localStorage.get(cachekey, true)
  if (cacheProps && cacheProps.configVersion == version && !getParam("sandbox")) {
    return Promise.resolve(cacheProps.content)
  } else {
    return request
      .ajax({
        url,
        data: {
          t: +new Date(),
        },
      })
      .then(res => {
        const result = {
          configVersion: version,
          content: res,
        }
        localStorage.set(cachekey, JSON.stringify(result))
        return res
      })
      .catch(() => {
        return {}
      })
  }
}

export function usePropsConfig(store: Store): {
  propsConfig: any
  isNonConsumableProduct: ComputedRef
  isConsumableProduct: ComputedRef
  nonConsumableProductPrice: ComputedRef
  consumableProductPrice: ComputedRef
  propsGroupId: ComputedRef
} {
  const propsConfig = ref<any>(null)

  const isNonConsumableProduct = computed(() => {
    return store.state.config.productType === PRODUCT_TYPE.NON_CONSUME_PROPS
  })
  // 消耗型道具
  const isConsumableProduct = computed(() => {
    return store.state.config.productType === PRODUCT_TYPE.CONSUME_PROPS
  })

  const nonConsumableProductPrice = computed(() => {
    if (
      new Date(propsConfig.value?.goodsExtend?.ActivityBegin?.replace(/-/g, "/")) <= store.getters.now &&
      new Date(propsConfig?.value?.goodsExtend?.ActivityEnd?.replace(/-/g, "/")) >= store.getters.now
    ) {
      return ((propsConfig.value?.goodsExtend?.ActivityPrice * 100) / 10000).toString()
    } else {
      return ((propsConfig.value?.goodsSalesPrice * 100) / 10000).toString()
    }
  })

  // 消耗型道具价格 -- 与非消耗型一样取价格，只是换个字段名好区分
  const consumableProductPrice = computed(() => {
    return nonConsumableProductPrice.value
  })

  const propsGroupId = computed(() => {
    if (
      new Date(propsConfig.value?.goodsExtend?.ActivityBegin?.replace(/-/g, "/")) <= store.getters.now &&
      new Date(propsConfig?.value?.goodsExtend?.ActivityEnd?.replace(/-/g, "/")) >= store.getters.now
    ) {
      return propsConfig.value?.goodsExtend?.ActivityNum
    } else {
      return undefined
    }
  })

  if (isNonConsumableProduct.value || isConsumableProduct.value) {
    const storeConfigEnv = getParam("store_config_env")
    let vmallConfigUrl = store.state.config.propsConfig.url

    if (storeConfigEnv && parseInt(storeConfigEnv) > 0) {
      vmallConfigUrl =
        vmallConfigUrl.split(".json")[0].indexOf("_sandbox") > -1
          ? vmallConfigUrl
          : `${vmallConfigUrl.split(".json")[0]}_sandbox.json`
    }

    getPropsConfig({
      url: vmallConfigUrl,
      version: window?.vmallMD5Config?.[store.state.config.propsConfig.md5key],
      cachekey: store.state.config.propsConfig.cachekey,
    }).then((res: any) => {
      propsConfig.value = res?.[store.state.productId]
    })
  }
  return {
    propsConfig,
    isNonConsumableProduct,
    isConsumableProduct,
    nonConsumableProductPrice,
    consumableProductPrice,
    propsGroupId,
  }
}
